<template>
  <div class="main-container">
    <div class="main-image">
      <img class="pc_main_image" src="../assets/img/main_image.png" alt="main_image" />
      <img class="t_main_image" src="../assets/img/t_main_image.png" alt="main_image" />
      <img class="m_main_image" src="../assets/img/mobile_img.png" alt="main_image" />
    </div>


    <div class="guide">
      <div class="pc">
        <h2 :style="{ fontSize: '30px' }">OPSIS User Manuals</h2>
        <p :style="{ textAlign: 'center' }">
          Guides for setup, features, and troubleshooting.
        </p>
        <div :style="{ display: 'flex', flexDirection: 'column', marginTop: '12px', alignItems: 'center' }">
          <button class="btn-download" style="display: flex; align-items: center; justify-content: center"
            @click="goToManuals()"
          >
            <img src="../assets/img/icon_pdf.png" alt="windows" width="40" style="margin-right: 8px" /><b>Open manuals</b>
          </button>
        </div>
      </div>
      <div class="app">
        <h2 style="font-size: 30px">Instruction Video</h2>
        <p :style="{ textAlign: 'center' }">
          Step-by-step video to get started quickly.
        </p>
        <div :style="{ display: 'flex', flexDirection: 'column', marginTop: '12px', alignItems: 'center' }">
          <button class="btn-download" style="display: flex; align-items: center; justify-content: center"
            @click="goToInstructionVideo()"
          >
            <img src="../assets/img/icon_video.png" alt="windows" width="40" style="margin-right: 8px" /><b>Watch now</b>
          </button>
        </div>
      </div>
    </div>

    <div class="download">
      <div class="pc">
        <h2 :style="{ fontSize: '30px' }">PC Viewer</h2>
        <p :style="{ textAlign: 'center' }">
          PC software to view settings and videos from the SD card of<br />
          OPSIS by Stinger device.
        </p>
        <div :style="{ display: 'flex', flexDirection: 'column', marginTop: '12px', alignItems: 'center' }">
          <button class="btn-download" style="display: flex; align-items: center; justify-content: center"
            @click="download('https://www.opsisbystinger.com/opsisbystinger_release.zip')"
          >
            <img src="../assets/img/windows.png" alt="windows" style="margin-right: 8px" />Download for &nbsp;<b>Windows</b>
          </button>
          <button class="btn-download" style="margin-top: 20px; display: flex; align-items: center; justify-content: center"
            @click="download('https://s3.us-west-1.amazonaws.com/www.echomasteropsis.com/opsis_mac.pkg')"
          >
            <img src="../assets/img/mac.png" alt="mac" style="margin-right: 8px" />Download for &nbsp;<b>MAC</b>
          </button>
        </div>
      </div>
      <div class="app">
        <h2 style="font-size: 30px">APP Download</h2>
        <div style="display: flex; width: 100%; justify-content: space-evenly; margin-top: 48px">
          <div style="display: flex; flex-direction: column; align-items: center">
            <p style="text-align: center;">APP<br />Store</p>
            <div style="margin-top: 8px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 12px">
              <a href="https://itunes.apple.com/app/id6449980489?mt=8" target="_blank">
                <img src="../assets/img/appstore-badge.png" alt="app store" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.aampglobal.dashcamapp" target="_blank">
                <img src="../assets/img/googleplay-badge.png" alt="google play" />
              </a>
            </div>
          </div>
          <div style="display: flex; flex-direction: column; align-items: center">
            <p style="text-align: center;">QR<br />code</p>
            <img class="qrcode" src="../assets/img/qrcode.png" alt="app store" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      manualUrl: 'https://stingersolutions.zendesk.com/hc/en-us/p/opsis_manuals',
      instructionVideoUrl: 'https://stingersolutions.zendesk.com/hc/en-us/p/opsis_videos',
    };
  },
  methods: {
    download (url) {
      window.location.href = url;
    },
    goToInstructionVideo() {
      window.location.href = this.instructionVideoUrl;
    },
    goToManuals() {
      window.location.href = this.manualUrl;
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.qrcode {
  width: 120px;
  height: 120px;
  border-radius: 8px;
}
.main-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: spac;
  align-items: center;
}

.main-image {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  img {
    width: 100%;
    height: auto;
  }
}

.pc_main_image {
  display: block;
}

.t_main_image {
  display: none;
}

.m_main_image {
  display: none;
}

@media (max-width: 768px) {
  .pc_main_image {
    display: none;
  }
  
  .t_main_image {
    display: block;
  }
}

@media (max-width: 450px) {
  .t_main_image {
    display: none;
  }
  
  .m_main_image {
    display: block;
  }
}

.mobile-main-image {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  display: none;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 768px) {
    display: block;
  }
}

.guide {
  margin-top: 36px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  .pc,
  .app {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background-color: #31373e;
  }
}


.download {
  margin-top: 36px;
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }

  .pc,
  .app {
    display: flex;
    flex-direction: column;
    padding-top: 40px;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    background-color: #31373e;
  }
}

.resources {
  margin-top: 28px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 24px;
  padding: 0 16px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
}

.resource-card {
  position: relative;
  width: 100%;
  max-width: 520px;
  min-height: 140px;
  border-radius: 12px;
  background: linear-gradient(180deg, #2a3037 0%, #252a31 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-decoration: none;
  color: inherit;
  overflow: hidden;
  transition: transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease;
  display: flex;
  align-items: center;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(248, 221, 74, 0.8);
    box-shadow: 0 10px 30px rgba(248, 221, 74, 0.15);
  }
}

.resource-content {
  padding: 20px 24px;
  width: 100%;

  h3 {
    margin: 0 0 6px 0;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 0.2px;
  }

  p {
    margin: 0 0 14px 0;
    color: #c9d1d9;
    line-height: 1.4;
    font-size: 14px;
  }
}

.resource-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background-color: rgba(248, 221, 74, 1);
  color: #000;
  border-radius: 999px;
  font-weight: 700;
  font-size: 14px;
}

.btn-download {
  width: 300px;
  height: 72px;
  border-radius: 36px;
  background-color: rgba(248, 221, 74, 1);
  text-align: center;
  color:#000;
}
</style>
